import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsList } from '@/entities/channel';
import { initTelegramPhoneAuth } from '@/shared/api/channels/telegramPersonal';
import { IInitSmsQueryDTO } from '@/shared/api/channels/types';
import { useNotifications } from '@/shared/ui/Notifications';

export function useInitSms() {
  const { t } = useTranslation();

  const { addNotification } = useNotifications();
  const invalidateChannelsList = useInvalidateChannelsList();

  const initSmsMutation = useMutation({
    mutationFn: (data: IInitSmsQueryDTO) =>
      initTelegramPhoneAuth(data.channelId, { phone: data.phone }),
    onError: (error) => {
      addNotification({
        title: error.message || t('common:errors.genericTitle'),
        caption: error?.data?.details || t('common:errors.generic'),
      });
    },
  });

  const initSms = async (data: IInitSmsQueryDTO) => {
    return initSmsMutation.mutateAsync(data, {
      onSuccess: () => {
        Promise.all([invalidateChannelsList()]);
      },
    });
  };

  return { initSms, ...initSmsMutation };
}
